export const siteConfig = {
  name: "51暗网安全指南",
  tagline: "深度解析暗网世界，守护你的数字安全",
  description:
    "51暗网安全指南是专业的中文网络安全教育平台，提供暗网知识科普、风险识别、个人信息防护技巧及法律法规解读，帮助网民安全上网。",
  url: "https://darknet-safety-guide.readdy.ai",
  locale: "zh_CN",
  type: "website",
  author: "51暗网安全指南团队",
  foundingDate: "2024-01-01",
  email: "contact@darknet-safety-guide.readdy.ai",
  phone: "400-000-0000",
  address: "北京市海淀区中关村网络安全产业园",
  social: {
    weibo: "https://weibo.com/darknet-safety",
    wechat: "darknet-safety-guide",
  },
};